import React from "react";
import { ArrowUpRight } from "lucide-react";
import { NEWS_URL } from "@/components/site/Navbar";

const posts = [
  { tag: "Industry", date: "June 2026", title: "Why Seismic Joint Design Matters More Than Ever in Philippine Construction" },
  { tag: "Technical", date: "May 2026", title: "Choosing Between Strip Seal and Modular Joints for Bridge Decks" },
  { tag: "Company", date: "April 2026", title: "Seisfra Expands Nationwide Supply Capability for 2026 Infrastructure Projects" },
];

export default function NewsTeaser() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <p className="font-tech font-semibold uppercase tracking-[0.2em] text-[#E4001C] text-sm mb-3">Insights</p>
            <h2 className="font-heading font-extrabold uppercase text-4xl md:text-5xl tracking-wide text-[#171717]">Latest News</h2>
          </div>
          <a href={NEWS_URL} target="_blank" rel="noopener noreferrer"
            className="font-tech font-semibold uppercase tracking-widest text-sm text-[#171717] hover:text-[#E4001C] transition-colors inline-flex items-center gap-1">
            All Posts <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((p) => (
            <a key={p.title} href={NEWS_URL} target="_blank" rel="noopener noreferrer"
              className="group border border-gray-200 p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#E4001C]/40 flex flex-col">
              <div className="flex items-center gap-3 mb-6">
                <span className="bg-[#0A0A0A] text-white font-tech uppercase tracking-widest text-xs px-3 py-1">{p.tag}</span>
                <span className="text-xs text-[#6B7280] font-tech tracking-widest uppercase">{p.date}</span>
              </div>
              <h3 className="font-tech font-semibold text-xl leading-snug text-[#171717] group-hover:text-[#E4001C] transition-colors flex-1">{p.title}</h3>
              <span className="inline-flex items-center gap-2 mt-6 font-tech font-semibold uppercase tracking-widest text-sm text-[#E4001C]">
                Read More <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}